import {
  CouponCollectionListUrlFilters,
  CouponCollectionListUrlFiltersEnum,
  CouponCollectionListUrlQueryParams
} from "@saleor/coupons/url";
import { CollectionFilterInput } from "@saleor/types/globalTypes";
import { createFilterUtils } from "@saleor/utils/filters";

export function getFilterVariables(
  params: CouponCollectionListUrlFilters
): CollectionFilterInput {
  return {
    search: params.query
  };
}

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CouponCollectionListUrlFilters,
  CouponCollectionListUrlQueryParams
>({ ...CouponCollectionListUrlFiltersEnum });
